import { render, staticRenderFns } from "./ApplyWithDetails.vue?vue&type=template&id=6fd8e865&scoped=true&"
import script from "./ApplyWithDetails.vue?vue&type=script&lang=js&"
export * from "./ApplyWithDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApplyWithDetails.vue?vue&type=style&index=0&id=6fd8e865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd8e865",
  null
  
)

export default component.exports